<template>
  <div class="header">
    <div
      class="float-left"
      style="
        padding: 10px 10px 0px 10px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div>
        <div class="logo">
          <a href="http://krasecology.ru" class="ke">
            <img src="../assets/sheet.png" width="40px" alt="logo" />
          </a>
          <a href="/">
            <h1 class="inline-block">
              Несанкционированные объекты размещения отходов
            </h1>
          </a>
        </div>
        <menu-header :menu="menu" />
      </div>

      <template v-if="!isLoggedIn">
        <div class="info">
          <button
            class="login-btn"
            @click="$router.push({ name: 'login' })"
            style="font-size: 1.5em; font-weight: bold"
          >
            войти
          </button>
        </div>
      </template>
      <template v-else>
        <div class="info">
          <span v-if="!isMobile()">
            Добро пожаловать <br />
            {{ email }}
          </span>
          <v-btn x-small @click="logout()">выйти</v-btn>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/menu-component.vue";
import { isMobile } from "mobile-device-detect";

export default {
  components: {
    "menu-header": Menu,
  },
  data() {
    return {
      menu: [
        {
          link: "/#/",
          name: "Главная",
          sub: [],
          perm: "",
        },
        {
          link: "/#/edit",
          name: "Панель редактирования",
          sub: [],
          perm: "noro:object:e",
        },
      ],
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    email: function () {
      return this.$store.getters.email;
    },
  },
  methods: {
    isMobile() {
      return isMobile;
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>

<style scoped>
.header {
  line-height: 1.3;
  z-index: 200;
}
div.header a {
  text-decoration: none;
  color: black;
}
div.header a.ke {
  margin-right: 10px;
  display: inline-block;
}
div.header div.logo {
  display: flex;
  align-items: center;
}
div.header h1 {
  color: white;
  font-size: 1.4em;
  padding: 0px;
  margin: 0px;
  text-shadow: 1px 1px 5px #0d579c;
}
div.header {
  background: #afc5d8;
  width: 100%;
  box-shadow: 0 0 10px #768ca0;
  margin-bottom: 10px;
}

div.header div.info {
  background-color: rgba(255, 255, 255, 0) !important;
  border-color: rgba(33, 150, 243, 0) !important;
  text-align: right;
  display: inline-block;
  width: 200px;
}
.login-btn {
  font-size: 1.5em;
  font-weight: bold;
}
.login-btn:hover {
  opacity: 0.75;
}
</style>
